module.exports = __webpack_public_path__ + "assets/icon_annual_agreement_default.eeb1d2c6.svg";